import { graphql } from "gatsby"
import React from "react"
import PropTypes from "prop-types"
import Img from "../../components/core/img"
import LazySVGImg from "../lazy-svg"

import Container from "../container"
import PullBelowHeader from "../containers/pull-below-header"
import SkewedBackground from "../../components/decoration/skewed-background"
import HeroContainer from "../containers/hero"
import GithubStats from "../github-stats"
import { Button, ButtonGroup } from "../core/button"
import { rhythm } from "../../utils/typography"
import { LayoutWidth } from "../../components/shared/constants/layout"

import Title from "./title.js"
import Subtitle from "./subtitle.js"

class Hero extends React.Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    image: PropTypes.object,
  }

  render() {
    const { page, image } = this.props

    const { quickLinks } = page
    const ctaOrg = quickLinks && quickLinks[0] ? quickLinks[0] : null
    const ctaPreview = quickLinks && quickLinks[0] ? quickLinks[1] : null

    return (
      <PullBelowHeader>
        <HeroContainer
          isInverted
          css={theme => ({
            paddingBottom: theme.space[15],
            background: theme.colors.purple[90],
            overflow: `hidden`,
          })}
        >
          <SkewedBackground shape="wave" />
          <div
            css={theme => ({
              position: `absolute`,
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              [theme.mediaQueries.tablet]: {
                transform: `translateY(50%)`,
              },
            })}
          >
            <div
              css={theme => ({
                positon: `relative`,
                [theme.mediaQueries.hd]: {
                  width: `90%`,
                  margin: `0 auto`,
                  maxWidth: `${LayoutWidth}rem`,
                },
              })}
            >
              <div
                css={theme => ({
                  [theme.mediaQueries.tablet]: { position: `relative` },
                })}
              >
                <div
                  css={theme => ({
                    position: `absolute`,
                    left: 0,
                    right: 0,
                    pointerEvents: `none`,
                    userSelect: `none`,
                    opacity: 0.5,
                    [theme.mediaQueries.tablet]: {
                      opacity: 1,
                      left: `35%`,
                      transform: `translateX(10%)`,
                    },
                    "& .gatsby-image-wrapper": {
                      top: `50%`,
                      transform: `translateY(-50%)`,
                    },
                  })}
                >
                  <LazySVGImg
                    src="bg-home.svg"
                    alt=""
                    css={{
                      position: `absolute`,
                      transform: `translateY(-50%)`,
                      left: 0,
                      right: 0,
                      margin: 0,
                      width: `100%`,
                    }}
                  />
                  {image && <Img alt={``} fluid={image.fluid} />}
                </div>
              </div>
            </div>
          </div>
          <Container>
            <div>
              <Title
                isInverted
                css={theme => ({
                  "& span": {
                    color: theme.colors.white,
                  },
                  [theme.mediaQueries.mobile]: {
                    maxWidth: rhythm(14),
                  },
                  [theme.mediaQueries.phablet]: {
                    maxWidth: rhythm(17),
                  },
                  [theme.mediaQueries.desktop]: {
                    maxWidth: rhythm(19),
                  },
                })}
              >
                {page.title}
              </Title>
              {page.subtitle && (
                <Subtitle
                  isInverted
                  css={{
                    marginTop: 0,
                    maxWidth: rhythm(18),
                  }}
                >
                  {page.subtitle.subtitle}
                </Subtitle>
              )}
              <div>
                <ButtonGroup
                  css={theme => ({
                    justifyContent: `left`,

                    [theme.mediaQueries.tablet]: {
                      alignItems: `flex-end`,
                    },
                  })}
                >
                  {ctaOrg && (
                    <Button to={`/get-started`}>{ctaOrg.displayTitle}</Button>
                  )}
                  {ctaPreview && (
                    <div
                      css={{
                        display: `flex`,
                        flexDirection: `column`,
                      }}
                    >
                      <span
                        css={theme => ({
                          color: theme.colors.white,
                          fontSize: theme.fontSizes[1],
                          opacity: 0.5,
                          margin: `0 0 ${theme.space[3]} ${theme.space[2]}`,
                        })}
                      >
                        Already have a Gatsby site?
                      </span>
                      <Button to={ctaPreview.url} buttonStyle="secondary">
                        {ctaPreview.displayTitle}
                      </Button>
                    </div>
                  )}
                </ButtonGroup>
                <GithubStats />
              </div>
            </div>
          </Container>
        </HeroContainer>
      </PullBelowHeader>
    )
  }
}

export const HomepageHeroImageFragment = graphql`
  fragment HomepageHeroImage on Query {
    homepageHeroImage: file(relativePath: { regex: "/globe.png/" }) {
      childImageSharp {
        fluid(maxWidth: 1228, quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Hero
